import { render, staticRenderFns } from "./combatTeamForTop_index.vue?vue&type=template&id=57826ce6&scoped=true"
import script from "./combatTeamForTop_index.vue?vue&type=script&lang=js"
export * from "./combatTeamForTop_index.vue?vue&type=script&lang=js"
import style0 from "./combatTeamForTop_index.vue?vue&type=style&index=0&id=57826ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57826ce6",
  null
  
)

export default component.exports